import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import ChevronForwardIcon from '../../../../../../static/icons/ic_chevron_forward_small_24.svg';
import Icon from '../../../../../components/Icon/Icon';
import { messages as myMusicMessages } from '../../../../../constants/Collection';

import './ArtistRowItemSecondText.scss';

interface IArtistRowItemSecondText {
  href: string;
}

const ArtistRowItemSecondText = ({ href }: IArtistRowItemSecondText): $TSFixMe => {
  const secondText = (
    <React.Fragment>
      <FormattedMessage {...myMusicMessages.moreByThisArtist} />
      <Icon className='ArtistRowItemSecondText__chevron' glyph={ChevronForwardIcon} />
    </React.Fragment>
  );

  return href ? (
    <Link to={href} className='ArtistRowItemSecondText'>
      {secondText}
    </Link>
  ) : (
    secondText
  );
};

export default ArtistRowItemSecondText;
